import * as React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { usePartnersQuery } from "../Slices/roomNateApis";
import { useGlobalAuthContext } from "../context/AuthContext";
import { useGlobalContext } from "../context/GlobalContext";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

/**
 * Same partner filter as the admin sidebar — persists via cookie + GlobalContext.
 */
export default function AdminPartnerSelect({ sx, size = "small", label = "Partner" }) {
  const selectLabelId = React.useId();
  const { activePartner, setActivePartner } = useGlobalContext();
  const { currentUserSessionStorage } = useGlobalAuthContext();
  const isAdmin = React.useMemo(() => {
    if (!currentUserSessionStorage) return false;
    try {
      return jwtDecode(currentUserSessionStorage)?.user?.role === "admin";
    } catch {
      return false;
    }
  }, [currentUserSessionStorage]);

  const { data: partnersData } = usePartnersQuery("", {
    skip: !currentUserSessionStorage || !isAdmin,
  });

  if (!isAdmin) return null;

  const handlePartnerChange = (e) => {
    const id = e.target.value;
    setActivePartner(id);
    Cookies.set("activePartner", id, { expires: 30 });
  };

  return (
    <FormControl size={size} fullWidth sx={{ minWidth: 0, ...sx }}>
      <InputLabel id={selectLabelId} sx={{ fontSize: "0.8125rem" }}>
        {label}
      </InputLabel>
      <Select
        labelId={selectLabelId}
        value={activePartner ?? ""}
        onChange={handlePartnerChange}
        label={label}
        sx={{ fontSize: "0.8125rem", borderRadius: "10px" }}
      >
        <MenuItem value="">All Partners</MenuItem>
        {partnersData?.map((partner) => (
          <MenuItem key={partner._id} value={partner._id}>
            {partner.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
